import { RouteObject } from "react-router";

export const SignedDocsRoutes: RouteObject[] = [
  {
    path: "",
    async loader(args) {
      const { signedDocsLoader } = await import("src/router/loaders/SignedDocs");
      return signedDocsLoader(args);
    },
    async lazy() {
      const { List } = await import("src/signedDocs/List");
      return { element: <List /> };
    },
  },
];
